import { AbstractReelProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractReelProperties";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import * as PIXI from "pixi.js";
import { GameStyle } from "../style/GameStyle";
import { Point } from "pixi.js";
export var ReelAnim;
(function (ReelAnim) {
    ReelAnim[ReelAnim["LAND"] = 0] = "LAND";
    ReelAnim[ReelAnim["LOOP"] = 1] = "LOOP";
    ReelAnim[ReelAnim["STATIC"] = 2] = "STATIC";
    ReelAnim[ReelAnim["PANELHIT"] = 3] = "PANELHIT";
})(ReelAnim || (ReelAnim = {}));
/**
 * GameReelProperties.ts
 */
export class GameReelProperties extends AbstractReelProperties {
    setDefaultValues() {
        this.disabledProperties = new SpriteProperties(SlingoStyle.REEL_SYMBOL_DISABLED, SlingoStyle.MODULE);
        this.symbolAnimationSpineProperties = new SpineProperties(GameStyle.REEL_SYMBOL_ANIMATION, GameStyle.MODULE, new PIXI.Point(80, 80), new PIXI.Point(1, 1));
        this.wildAnims = ["wild_Land", "wild_win", "wild_static"];
        this.superWildAnims = ["super_wild_Land", "super_wild_win", "super_wild_static"];
        this.scatterAnims = ["scatter_land", "scatter_win", "scatter_static"];
        this.numberAnims = ["ReelNumberAnimation_land", "ReelNumberAnimation_ready", undefined];
        this.freeSpinAnims = ["free_spins_win", "free_spins_Land", "free_spins_static"];
        this.collectibleAnims = ["collect_symbol_land", undefined, "collect_symbol_static", "collect_symbol_PanelHit"];
        this.suspenseAnim = "suspenseSpinEffect";
        this.symbolIDToStaticMap = {
            [GameStyle.JOKER]: "Wild",
            [GameStyle.SUPER_JOKER]: "SuperWild",
            [GameStyle.FREE_SPIN]: "FreeSpin",
            [GameStyle.COIN]: "Coin",
            [GameStyle.DEVIL]: "Devil",
        };
        this.motionBlur = new PIXI.Point(0, 50);
        this.reelSetsStandard = [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "J", "SJ", "FS", "D"],
            ["16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "J", "SJ", "FS", "D"],
            ["31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "J", "SJ", "FS", "D"],
            ["46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "J", "SJ", "FS", "D"],
            ["61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "J", "SJ", "FS", "D"]
        ];
        this.reelSetsPurchase = [
            ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "J", "SJ"],
            ["16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "J", "SJ"],
            ["31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "J", "SJ"],
            ["46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "J", "SJ"],
            ["61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "J", "SJ"]
        ];
        this.numberSprites = this.reelSetsStandard
            .flat()
            .filter(id => !isNaN(parseInt(id)))
            .map(id => id.length === 1 ? `0${id}` : id)
            .map(id => {
            return new SpriteProperties(`reel${id}`, "NumberAssets", new Point(0, 0), new PIXI.Point(1, 1), new PIXI.Point(0.5, 0.5));
        });
    }
}
//# sourceMappingURL=GameReelProperties.js.map